import { User } from '@prisma/client';
import { StateCreator } from 'zustand';
import { AuthStore } from './types';

export interface AuthSlice {
  user: User | null;
  setUser: (user: User | null) => void;
  logout: () => void;
  setPermissionUser: (user: { roles: string[] }) => void;
}

export const createAuthSlice: StateCreator<AuthStore, [['zustand/devtools', never]], [], AuthSlice> = (
  set
) => ({
  user: null,
  setUser: (user) => set({ user }),
  logout: () => {
    set({ user: null });
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
  },
  setPermissionUser: (user) => {
    // Update permissions in global state
    set((state) => ({
      ...state,
      permissionUser: user,
    }));
  },
});
